import Footer from "../landing-new/Footer"
import Faq02 from "./components/FAQSection"
import Header from "./components/Header"
import Hero from "./components/Hero"
import Information from "./components/Information"
import InformationAndWhy from "./components/InformationAndWhy"
import InformationNew from "./components/InformationNew"
import LastSection from "./components/LastSection"
import Testimonials from "./components/Testimonials"


const LandingReView = () => {
  return (
    <div className="w-full  snap-y snap-mandatory">
      <div className="snap-center">
        <Header />
        <Hero />
      </div>
      <Information />
      <InformationAndWhy />
      <Testimonials />
      <InformationNew />
      <LastSection />
      <Faq02 />
      <Footer />
    </div>
  )
}

export default LandingReView
